import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function SimpleSlider() {
  const settings = {
    dots: true,
    arrow: false,
    infinite: true,
    speed: 900,
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay: false,
    margin: 30,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const TestimonilContent = [
    {
      imageName: "team-1",
      desc: `"La migración a Google Cloud de nuestra infraestructura fue impecable. Activo Digital nos dio la estabilidad que nuestra planta necesitaba para operar sin interrupciones."`,
      reviewerName: "Ing. Ricardo Méndez",
      designation: "Director de Operaciones | Industria & Infraestructura",
      delayAnimation: "",
    },
    {
      imageName: "team-2",
      desc: `"Tenía miedo de dar el salto al comercio en línea, pero su equipo me guió paso a paso. Hoy nuestra tienda es automática, eficiente y visualmente increíble."`,
      reviewerName: "Elena Rodríguez",
      designation: "Fundadora de Retail Solutions | E-commerce & Ventas",
      delayAnimation: "200",
    },
    {
      imageName: "team-3",
      desc: `"Implementar Google Workspace con ellos cambió nuestra cultura de trabajo. El soporte técnico responde con una velocidad que no habíamos encontrado en ninguna otra agencia."`,
      reviewerName: "Mauricio Arreola",
      designation: "Gerente Administrativo | Corporativo & Productividad",
      delayAnimation: "400",
    },
    {
      imageName: "team-4",
      desc: `"Democratizan la tecnología. Nos dieron acceso a herramientas de primer nivel que pensamos eran solo para grandes empresas, ajustándose siempre a nuestro presupuesto."`,
      reviewerName: "Sofía Valenzuela",
      designation: "Directora de Crecimiento | Emprendimiento & Escala",
      delayAnimation: "600",
    },
    {
      imageName: "team-5",
      desc: `"Es un gusto trabajar con este equipo; no importa qué idea traigamos, saben cómo implementarla con pensamiento creativo. Mi sitio nunca se ha visto mejor."`,
      reviewerName: "Jesús Toral",
      designation: "Empresario | Cliente Recurrente",
      delayAnimation: "800",
    },
    {
      imageName: "team-6",
      desc: `"Arriesgarse con estos chicos fue la mejor decisión para mi proyecto web. Ahora somos clientes habituales gracias a su profesionalismo y resultados."`,
      reviewerName: "David Noriega",
      designation: "Empresario | Cliente Recurrente",
      delayAnimation: "1000",
    },
  ];

  return (
    <div className="testimonial-wrapper">
      <Slider {...settings}>
        {TestimonilContent.map((val, i) => (
          <div
            key={i}
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay={val.delayAnimation}
          >
            <div className="testimonial-01 media">
              <div className="avatar">
                <img
                  src={process.env.PUBLIC_URL + `/img/testimonial/${val.imageName}.png`}
                  alt="review comments"
                  width="80"
                  height="80"
                ></img>
              </div>
              <div className="media-body">
                <p style={{ fontStyle: 'italic' }}>{val.desc}</p>
                <h3 className="h6">{val.reviewerName}</h3>
                <span>{val.designation}</span>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
